import type { ShapeData } from '@/lib/shapes/types/shape-data'

/** A pasteboard pointer position in canvas (document) coordinates. */
type CanvasPoint = { canvasX: number; canvasY: number }

/** True when the canvas point lies inside the shape's unrotated `x/y/width/height` box. */
export function isCanvasPointInShapeBounds(
  pt: CanvasPoint,
  s: Pick<ShapeData, 'x' | 'y' | 'width' | 'height'>
): boolean {
  return (
    pt.canvasX >= s.x &&
    pt.canvasX <= s.x + s.width &&
    pt.canvasY >= s.y &&
    pt.canvasY <= s.y + s.height
  )
}

/** Topmost visible shape whose box contains the point — the click-away "select what was hit". */
export function findTopmostShapeAtCanvasPoint(
  shapes: ShapeData[],
  pt: CanvasPoint
): ShapeData | undefined {
  return [...shapes].reverse().find((s) => !s.hidden && isCanvasPointInShapeBounds(pt, s))
}
